import { CommonButton } from '@Components/common/Button';
import Link from '@Components/common/Link';
import Rate from 'rc-rate';
import 'rc-rate/assets/index.css';
import styled from 'styled-components';
import { mq } from 'stylesheets/utils';
export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 410px;
  ${mq(992)} {
    max-width: 100%;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
`;

export const HeaderCategory = styled.div`
  display: flex;
  flex-direction: column;
`;

export const IconWrapper = styled(Link)`
  display: flex;
  align-items: center;
  line-height: 1;
  margin-top: 8px;
`;

export const Icon = styled.div`
  max-width: 24px;
  min-width: 24px;
  max-height: 24px;
  min-height: 24px;
  margin-right: 10px;
`;

export const P = styled.p`
  font-weight: ${({ theme }) => theme.fontWeight.font400};
  color: ${({ theme }) => theme.colors.lightPurple};
  font-size: ${({ theme }) => theme.fontsizes.body14};
`;

export const HeaderReview = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Number = styled.h6`
  font-weight: ${({ theme }) => theme.fontWeight.font500};
  color: ${({ theme }) => theme.colors.black};
  font-size: ${({ theme }) => theme.fontsizes.h6};
`;

export const StyledRate = styled(Rate)`
  margin-bottom: 6px;
  &.rc-rate {
    height: 14px;
    font-size: ${({ theme }) => theme.fontsizes.body14};
    transform: translateY(-3px) /* rtl: none */;
    .rc-rate-star {
      margin-right: 2px;
      &:last-of-type {
        margin-right: 0;
      }
    }
  }
`;

export const Reviews = styled.p`
  font-weight: ${({ theme }) => theme.fontWeight.font400};
  color: ${({ theme }) => theme.colors.lightPurple};
  font-size: ${({ theme }) => theme.fontsizes.body14};
  text-transform: uppercase;
  line-height: 1;
`;

export const SubCategory = styled.p`
  font-weight: ${({ theme }) => theme.fontWeight.font400};
  color: ${({ theme }) => theme.colors.lightPurple};
  font-size: ${({ theme }) => theme.fontsizes.body14};
  transform: translateY(-4px);
`;

export const Description = styled.p`
  font-weight: ${({ theme }) => theme.fontWeight.font400};
  color: ${({ theme }) => theme.colors.black};
  font-size: ${({ theme }) => theme.fontsizes.body16};
  max-width: 320px;
  margin-bottom: 6px;
`;

export const Price = styled.p`
  font-weight: ${({ theme }) => theme.fontWeight.font400};
  color: ${({ theme }) => theme.colors.lightPurple};
  font-size: ${({ theme }) => theme.fontsizes.body16};
  position: relative;
  width: fit-content;
  line-height: 1;
  &::after {
    position: absolute;
    content: '';
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 100%;
    height: 1px;
    background-color: ${({ theme }) => theme.colors.lightPurple};
  }
`;

export const BluePrice = styled.h5`
  font-weight: ${({ theme }) => theme.fontWeight.font500};
  color: ${({ theme }) => theme.colors.auth.blue};
  font-size: ${({ theme }) => theme.fontsizes.h5};
  margin-bottom: 32px;
`;

export const FeaturesWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: 12px;
  border-top: 1px solid ${({ theme }) => theme.colors.lightenGray};
  margin-bottom: 20px;
`;

export const FeaturesList = styled.ul`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Feature = styled.li`
  list-style: none;
  position: relative;
  font-weight: ${({ theme }) => theme.fontWeight.font500};
  color: ${({ theme }) => theme.colors.auth.lightPurple};
  font-size: ${({ theme }) => theme.fontsizes.body14};
  padding-left: 20px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  &::before {
    position: absolute;
    content: '';
    left: 0;
    top: 5px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colors.green};
  }
  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const LogosList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  * {
    margin-bottom: 10px;
  }
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  /* justify-content: space-between; */
`;

export const AddToCard = styled.button`
  padding: 0;
  max-width: 332px;
  width: 100%;
  height: 48px;
  line-height: 48px;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.brandColor};
  font-size: ${({ theme }) => theme.fontsizes.body16};
  font-weight: ${({ theme }) => theme.fontWeight.font400};
  display: flex;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  padding: 12px 20px;
  border-color: ${({ theme }) => theme.colors.brandColor};
  border-radius: 4px;
  text-align: center;
  margin-left: 12px;
`;
export const CartIcon = styled.div`
  max-width: 24px;
  min-width: 24px;
  max-height: 22px;
  min-height: 22px;
  margin-left: 10px;
  display: flex;
`;

export const Like = styled.button`
  width: 48px;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid ${({ theme }) => theme.colors.brandColor};
  padding: 0;
  border-radius: 4px;
  transition: 0.3s ease opacity;
  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
`;
export const QuantityWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.lightBlue};
  color: ${({ theme }) => theme.colors.black};
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1;
  font-size: 2rem;
  font-weight: 500;
  user-select: none;
  height: 48px;
  max-width: 200px;
`;
export const QuantityBtn = styled(CommonButton)`
  color: ${({ theme }) => theme.colors.white};
  font-size: 2rem;
  height: 48px;
  min-width: 46px;
  max-width: 46px;
`;
